import { render, staticRenderFns } from "./WflowFlowDesigner.vue?vue&type=template&id=3fbaff42&scoped=true"
import script from "./WflowFlowDesigner.vue?vue&type=script&lang=js"
export * from "./WflowFlowDesigner.vue?vue&type=script&lang=js"
import style0 from "./WflowFlowDesigner.vue?vue&type=style&index=0&id=3fbaff42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbaff42",
  null
  
)

export default component.exports